(function () {
  var openingPreferences = false;

  function openPreferences() {
    if (openingPreferences) return;
    openingPreferences = true;
    var attempts = 0;

    function fail() {
      openingPreferences = false;
      console.warn('[cookie] Preferințele Shopify nu au putut fi deschise.');
    }

    function openWhenReady() {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        try {
          Promise.resolve(banner.showPreferences()).then(function () {
            openingPreferences = false;
          }, fail);
        } catch (error) {
          fail();
        }
        return;
      }
      attempts++;
      if (attempts < 100) window.setTimeout(openWhenReady, 100);
      else fail();
    }

    openWhenReady();
  }

  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element && event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    var popover = link.closest('[popover]');
    if (popover && typeof popover.hidePopover === 'function' && popover.matches(':popover-open')) {
      popover.hidePopover();
    }
    openPreferences();
  }, true);

  var choiceCookie = 'ddc_cookie_banner_choice';
  var pendingChoice = null;
  var saleConsentChoice = null;

  function hasBannerChoice() {
    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim() === choiceCookie + '=v1';
    });
  }

  function rememberBannerChoice() {
    document.cookie = choiceCookie + '=v1; Path=/; Max-Age=15552000; SameSite=Lax; Secure';
  }

  function verifyChoice(choice, attempts) {
    if (pendingChoice !== choice) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var current = privacy && typeof privacy.currentVisitorConsent === 'function'
      ? privacy.currentVisitorConsent() : null;
    if (current && ['analytics', 'marketing', 'preferences'].every(function (key) {
      return current[key] === (choice[key] ? 'yes' : 'no');
    })) {
      var dataSaleConsent = typeof choice.sale_of_data === 'boolean'
        ? choice.sale_of_data : choice.marketing ? null : false;
      if (dataSaleConsent !== null && current.sale_of_data !== (dataSaleConsent ? 'yes' : 'no')) {
        if (saleConsentChoice !== choice && typeof privacy.setTrackingConsent === 'function') {
          saleConsentChoice = choice;
          try {
            privacy.setTrackingConsent({ sale_of_data: dataSaleConsent }, function () {
              verifyChoice(choice, attempts + 1);
            });
          } catch (error) {
            console.warn('[cookie] Preferința privind partajarea datelor nu a putut fi actualizată.');
          }
        }
        if (attempts < 100) window.setTimeout(function () {
          verifyChoice(choice, attempts + 1);
        }, 100);
        else pendingChoice = null;
        return;
      }
      rememberBannerChoice();
      pendingChoice = null;
      return;
    }
    if (attempts < 100) window.setTimeout(function () {
      verifyChoice(choice, attempts + 1);
    }, 100);
    else pendingChoice = null;
  }

  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    var button = event.target.closest('button');
    if (!button) return;
    var choice;
    if (button.id === 'shopify-pc__banner__btn-accept' || button.id === 'shopify-pc__prefs__header-accept') {
      choice = { analytics: true, marketing: true, preferences: true, sale_of_data: true };
    } else if (button.id === 'shopify-pc__banner__btn-decline' || button.id === 'shopify-pc__prefs__header-decline') {
      choice = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
    } else if (button.id === 'shopify-pc__prefs__header-save') {
      var analytics = document.getElementById('shopify-pc__prefs__analytics-input');
      var marketing = document.getElementById('shopify-pc__prefs__marketing-input');
      var preferences = document.getElementById('shopify-pc__prefs__preferences-input');
      if (!analytics || !marketing || !preferences) return;
      choice = { analytics: analytics.checked, marketing: marketing.checked, preferences: preferences.checked };
    }
    if (!choice) return;
    pendingChoice = choice;
    window.setTimeout(function () { verifyChoice(choice, 0); }, 100);
  }, true);

  function showInitialBanner(attempts) {
    if (hasBannerChoice() || pendingChoice) return;
    var banner = window.privacyBanner;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (banner && typeof banner.showBanner === 'function' && privacy && typeof privacy.shouldShowBanner === 'function') {
      if (!privacy.shouldShowBanner()) return;
      var existing = document.getElementById('shopify-pc__banner');
      if (existing && existing.getClientRects().length) return;
      Promise.resolve(banner.showBanner()).catch(function () {
        console.warn('[cookie] Bannerul Shopify nu a putut fi afișat.');
      });
      return;
    }
    if (attempts < 100) window.setTimeout(function () {
      showInitialBanner(attempts + 1);
    }, 100);
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (pendingChoice) return;
    if (!hasBannerChoice()) window.setTimeout(function () { showInitialBanner(0); }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { showInitialBanner(0); }, { once: true });
  } else showInitialBanner(0);

  var labels = {
    'shopify-pc__banner__btn-manage-prefs': 'Administrează preferințele',
    'shopify-pc__banner__btn-decline': 'Refuzǎ',
    'shopify-pc__banner__btn-accept': 'Accept',
    'shopify-pc__prefs__header-close': 'Închide',
  };
  var buttonIds = Object.keys(labels);
  var buttonSelector = '#' + buttonIds.join(', #');
  var buttons = {};
  var buttonObserver;

  function isConnected(button) {
    return 'isConnected' in button ? button.isConnected : document.documentElement.contains(button);
  }

  function watchButtons() {
    if (!buttonObserver) return;

    buttonObserver.disconnect();
    buttonIds.forEach(function (id) {
      if (buttons[id]) buttonObserver.observe(buttons[id], { childList: true, subtree: true });
    });
  }

  function localizeButton(button) {
    if (button && button.id === 'shopify-pc__prefs__header-close') {
      if (button.getAttribute('aria-label') !== labels[button.id]) {
        button.setAttribute('aria-label', labels[button.id]);
      }
      return;
    }
    if (button && button.textContent.trim() !== labels[button.id]) {
      button.textContent = labels[button.id];
    }
  }

  function updateBannerCopy(text) {
    if (!text || text.getAttribute('data-ddc-copy') === '1') return;
    var policy = text.querySelector('a');
    var content = document.createDocumentFragment();

    function line(value) {
      var span = document.createElement('span');
      span.className = 'ddc-cookie-copy-line';
      span.textContent = value;
      content.appendChild(span);
    }

    line('Salut!');
    line('Noi, la DepozitulDeCriogenati.ro, dorim să îți oferim o experiență cât mai plăcută. Folosim cookie-uri și tehnologii similare pentru:');
    var purposes = document.createElement('span');
    purposes.className = 'ddc-cookie-copy-list';
    purposes.setAttribute('role', 'list');
    [
      'funcționarea corectă a site-ului,',
      'analiza performanței, și',
      'personalizarea reclamelor.'
    ].forEach(function (value) {
      var item = document.createElement('span');
      item.setAttribute('role', 'listitem');
      item.textContent = value;
      purposes.appendChild(item);
    });
    content.appendChild(purposes);
    line('Prin apăsarea butonului „Accept”, ești de acord ca datele tale (precum activitatea pe site și informațiile despre dispozitiv) să fie utilizate de noi și de partenerii noștri pentru scopurile de mai sus. Dacă alegi „Refuzǎ”, vom folosi doar cookie-uri strict necesare funcționării site-ului și nu vom afișa reclame personalizate. Poți modifica preferințele oricând apăsând pe „Administrează preferințele”.');
    content.appendChild(document.createTextNode(' Află mai multe despre cookie-uri în '));
    if (policy) content.appendChild(policy.cloneNode(true));
    text.setAttribute('data-ddc-copy', '1');
    text.replaceChildren(content);
  }

  function orderPrivacyButtons() {
    var accept = document.getElementById('shopify-pc__banner__btn-accept');
    var decline = document.getElementById('shopify-pc__banner__btn-decline');
    var manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    if (accept && decline && manage && accept.parentNode === decline.parentNode && accept.parentNode === manage.parentNode) {
      if (accept.nextElementSibling !== decline) accept.parentNode.insertBefore(accept, decline);
      if (decline.nextElementSibling !== manage) decline.parentNode.insertBefore(manage, decline.nextElementSibling);
    }
    var text = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    updateBannerCopy(text);
    if (text && !text.hasAttribute('tabindex')) {
      text.setAttribute('tabindex', '0');
      text.setAttribute('role', 'region');
      text.setAttribute('aria-label', 'Informații despre modulele cookie — text derulabil');
    }
  }

  function localizePrivacyButtons() {
    buttonIds.forEach(function (id) {
      buttons[id] = document.getElementById(id);
      localizeButton(buttons[id]);
    });
    orderPrivacyButtons();
  }

  function hasMissingButtons() {
    var missing = false;
    var changed = false;

    buttonIds.forEach(function (id) {
      var button = buttons[id];
      if (button && (button.id !== id || !isConnected(button))) {
        buttons[id] = document.getElementById(id);
        localizeButton(buttons[id]);
        changed = true;
      }
      if (!buttons[id]) missing = true;
    });

    if (changed) watchButtons();
    return missing;
  }

  function discoverButtons(root) {
    if (root.nodeType !== 1 || !isConnected(root)) return;

    function rememberButton(button) {
      if (!buttons[button.id]) {
        buttons[button.id] = button;
        localizeButton(button);
        buttonObserver.observe(button, { childList: true, subtree: true });
      }
    }

    if (Object.prototype.hasOwnProperty.call(labels, root.id)) rememberButton(root);
    root.querySelectorAll(buttonSelector).forEach(rememberButton);
    orderPrivacyButtons();
  }

  function handleButtonMutations(mutations) {
    mutations.forEach(function (mutation) {
      buttonIds.forEach(function (id) {
        var button = buttons[id];
        if (button && isConnected(button) && button.contains(mutation.target)) localizeButton(button);
      });
    });
  }

  function handlePrivacyMutations(mutations) {
    if (!hasMissingButtons()) return;

    for (var i = 0; i < mutations.length; i += 1) {
      for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
        discoverButtons(mutations[i].addedNodes[j]);
        if (!hasMissingButtons()) return;
      }
    }
  }

  localizePrivacyButtons();

  if ('MutationObserver' in window) {
    buttonObserver = new MutationObserver(handleButtonMutations);
    watchButtons();
    new MutationObserver(handlePrivacyMutations).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } else {
    document.addEventListener('DOMContentLoaded', localizePrivacyButtons);
  }
})();
